import { CardContent, CardHeader } from '@mui/material';
import { EpisodeMetrics } from 'api';
import PodcastContentTable from 'components/PodcastContentTable';
import useMobileBreakpoint from 'hooks/useMobileBreakpoint';
import { useEpisodeListenData } from 'pages/Play/state';
import React from 'react';
import PodcastEpisodesMobileList from './PodcastEpisodesMobileList';
import * as S from './styles';
import columns from './utils';

type PodcastEpisodesTableProps = {
  onRowClick?: (val: EpisodeMetrics) => void;
};

const PodcastEpisodesTable: React.FC<PodcastEpisodesTableProps> = ({
  onRowClick,
}) => {
  const {
    fetchNextPage,
    hasNextPage = false,
    isLoading,
    data,
  } = useEpisodeListenData();

  const isMobile = useMobileBreakpoint('md');

  return (
    <S.Card>
      <CardHeader title="Episodes played during this period" />
      <CardContent>
        {isMobile ? (
          <PodcastEpisodesMobileList
            data={data?.pages || []}
            hasMore={hasNextPage}
            onLoadMore={fetchNextPage}
          />
        ) : (
          <PodcastContentTable
            columns={columns}
            podcastData={data?.pages || []}
            isLoading={isLoading}
            tableLayout="fixed"
            hasMore={hasNextPage}
            infinite
            onLoadMore={fetchNextPage}
            onRowClick={onRowClick}
          />
        )}
      </CardContent>
    </S.Card>
  );
};
export default PodcastEpisodesTable;
